<div
  class="bg-card relative flex h-16 w-full flex-0 items-center gap-6 px-4 shadow dark:bg-default md:px-6 dark:border-b dark:shadow-none print:hidden"
>
  <div class="flex items-center gap-3">
    <!-- Navigation toggle button -->
    <button
      mat-icon-button
      aria-label="Open navigation"
      (click)="toggleNavigation.emit('mainNavigation')"
    >
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
  </div>

  @if (header(); as feature) {
    <div class="header-outlet flex min-w-0 flex-1">
      <ng-container
        *ngComponentOutlet="feature.component; inputs: feature.inputs"
      />
    </div>
  } @else {
    <div class="flex min-w-0 flex-1 items-center gap-2 md:gap-3">
      <!-- Navigation toggle button -->
      <div class="w-0 min-w-0 flex-[1_1_0%]">
        <span class="text-default block truncate text-lg font-semibold">
          {{ routeName() | titlecase }}
        </span>
      </div>

      <fuse-fullscreen
        class="ml-auto hidden shrink-0 md:inline-block"
      ></fuse-fullscreen>
      @if (isSupportChat()) {
        <button
          mat-icon-button
          class="flex items-center md:hidden"
          (click)="goToSupportChat()"
        >
          <mat-icon
            class="opacity-80"
            [svgIcon]="'mat_outline:headset'"
          ></mat-icon>
        </button>
      }
    </div>
  }
</div>
